import {SignatureRegistry} from 'components/grid-dx/consult-buttons/index';
import {useGetToken} from 'components/hooks';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React, {useState} from 'react';
import {useLoadCollaborator} from '../../collaborator/hooks';
import {useSelector} from 'react-redux';
import PopupReport from './../../../components/Popups/PopupReport';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

interface ButtonsProps {
  cwid: string;
  employee_Nr: number;
  data: any;
  props: any;
}

const Buttons = ({cwid, employee_Nr, data, props}: ButtonsProps) => {
  const token = useGetToken();
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <SignatureRegistry cwid={cwid} employee_Nr={employee_Nr} token={token} />
    </div>
  );
};

const CollaboratorReadOnly = () => {
  const loadCollaboratorReadOnly = useLoadCollaborator(
    'CollaboratorReadOnlyJOIN',
  );
  const [openReport, setOpenReport] = useState(false);
  const filters = useSelector((state: any) => state.gridReducer.filters);
  const isTablet = useIsTablet();

  return (
    <>
      <IntegrityRoleGrid
        dataSource={loadCollaboratorReadOnly}
        id={['iD_Instance', 'iD_Course', 'employee_Nr']}
        allowIntegrity={false}
        autoWidth={true}
        allowActions={false}
        shouldSaveOnlyFilters={true}
        exportName="Collaborator-consult-export"
        addCustomToolbar={[
          {
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'event',
              hint: i18n2._('Reporte'),
              onClick: () => setOpenReport(true),
            },
          },
        ]}>
        <Column caption={i18n2._('CWID')} dataField="cwid" />
        <Column
          caption={i18n2._('Numero de empleado')}
          dataField="employee_Nr"
        />
        <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
        <Column caption={i18n2._('Sector')} dataField="sector_Name" />
        <Column caption={i18n2._('Perfil')} dataField="profile_Web_Name" />
        <Column
          caption={i18n2._('#Instancia')}
          dataField="iD_Instance"
          visible={false}
        />
        <Column
          caption={i18n2._('#Curso')}
          dataField="iD_Course"
          visible={false}
        />
        <Column caption={i18n2._('Documento')} dataField="doc_Number" />
        <Column caption={i18n2._('Nombre del curso')} dataField="name_course" />
        <Column
          caption={i18n2._('Fecha de expiración')}
          dataField="expiration_Date"
          dataType="date"
          format="dd/MM/yyyy"
          calculateCellValue={(row: any) => new Date(row.expiration_Date)}
        />
        <Column caption={i18n2._('Duración')} dataField="duration" />
        <Column caption={i18n2._('Calificacion')} dataField="score" />
        <Column caption={i18n2._('Intento')} dataField="attempt" />
        <Column caption={i18n2._('En tiempo')} dataField="onTime" />
        <Column caption={i18n2._('Presente')} dataField="present" />
        <Column caption={i18n2._('Aprobado')} dataField="approved" />
        <Column
          caption=""
          cellComponent={(e: any) => (
            <Buttons
              cwid={e.data.data.cwid}
              employee_Nr={e.data.data.employee_Nr}
              data={e.data.data}
              props={e.data}
            />
          )}
          width={getActionColumnWidth(1, isTablet)}
          fixed
          alignment="right"
        />
      </IntegrityRoleGrid>
      <PopupReport
        open={openReport}
        setOpen={setOpenReport}
        name="Capacitacion_colaboradores"
        url="api/Report/CapaCollabReport"
        filters={filters}
        pdfOnly={false}
      />
    </>
  );
};

export default CollaboratorReadOnly;
